import { normalizeTimezoneIdentifier } from '@/Utils/timezone';

const createId = () => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    return `support-schedule-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

const normalizeTime = (value, fallback) => {
    if (!value) return fallback;
    return value.length === 5 ? `${value}:00` : value;
};

const cloneResolutionPriorities = (value) => (value ? JSON.parse(JSON.stringify(value)) : null);

export const resolveDefaultSupportScheduleTimezone = (timezones = []) => {
    const identifiers = timezones.map((timezone) => timezone.identifier).filter(Boolean);
    const browserTimezone = normalizeTimezoneIdentifier(Intl.DateTimeFormat().resolvedOptions().timeZone);

    const match = identifiers.find((id) => normalizeTimezoneIdentifier(id) === browserTimezone);

    return normalizeTimezoneIdentifier(match ?? identifiers[0] ?? 'UTC');
};

export const createSupportSchedule = (timezone = 'UTC', { startTime = '09:00', endTime = '17:00', days = [], resolutionPriorities = null } = {}) => ({
    id: createId(),
    name: null,
    isTwentyFourSeven: false,
    days: [...days],
    timezone,
    startTime: normalizeTime(startTime, '09:00:00'),
    endTime: normalizeTime(endTime, '17:00:00'),
    contacts: [],
    resolutionPriorities: cloneResolutionPriorities(resolutionPriorities),
});

export const normalizeSupportSchedules = (schedules, fallbackTimezone = 'UTC', defaults = {}) => {
    const startTime = defaults.startTime ?? '09:00';
    const endTime = defaults.endTime ?? '17:00';
    const days = Array.isArray(defaults.days) ? defaults.days : [];
    const resolutionPriorities = defaults.resolutionPriorities ?? null;

    if (!Array.isArray(schedules) || schedules.length === 0) {
        return [createSupportSchedule(fallbackTimezone, { startTime, endTime, days, resolutionPriorities })];
    }

    return schedules.map((schedule) => ({
        id: schedule?.id ?? createId(),
        name: schedule?.name ?? null,
        isTwentyFourSeven: Boolean(schedule?.isTwentyFourSeven),
        days: Array.isArray(schedule?.days) ? [...schedule.days] : [...days],
        timezone: normalizeTimezoneIdentifier(schedule?.timezone ?? fallbackTimezone),
        startTime: schedule?.startTime ?? startTime,
        endTime: schedule?.endTime ?? endTime,
        contacts: Array.isArray(schedule?.contacts)
            ? schedule.contacts.map((contact) => ({
                  contactId: contact?.contactId,
                  channelTypes: Array.isArray(contact?.channelTypes) ? [...contact.channelTypes] : [],
              }))
            : [],
        resolutionPriorities: schedule?.resolutionPriorities ?? cloneResolutionPriorities(resolutionPriorities),
    }));
};
